import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {PROJECT_STATUS} from '../../../../utils/constant';

function ListItemView(props) {
  const {project} = props;

  return (
    <tr onClick={props.onClickProject}>
      <td><span data-id="name">{project.name}</span></td>
      <td>
        {project.projectStatus === PROJECT_STATUS.CLOSED &&
          <span
            data-id="projectLabel"
            className="information"
          >
            <Translate value="project.closedProject"/>
          </span>
        }
      </td>
      <td><span data-id="fullName">{project.ownerOrganisation.fullName}</span></td>
      <td><span data-id="postCode">{project.address.postCode}</span></td>
      <td><span data-id="city">{project.address.city}</span></td>
      <td><span data-id="country"><Translate value={`country.${project.country}`}/></span></td>
    </tr>
  );
}

ListItemView.propTypes = {
  project: PropTypes.object.isRequired,
  onClickProject: PropTypes.func.isRequired
};

export default ListItemView;
